const PRO_ITEMS_COLUMNS = [
  { id: "product", label: "PRODUCT", width: 250, fixed:'left', widget: "mediaText" },
  { id: "customer", label: "CUSTOMER", width: 300 },
  { id: "total", label: "TOTAL", width: 150 },
  { id: "date", label: "DATE", width: 150, widget: "date" },
  { id: "status", label: "STATUS", width: 150,  widget: "status" }

];

const ROWS = [
 
  {
    product: "IPol Pro S6 5G",
    subProduct: "+3 Product",
    customer: "Alicent Adam",
    username: "@alicent",
    total: "$27,000",
    payment: "Transfer",
    date: "14 Jan 2024",
    time: "10:00",
    status: "Success"
  },
  {
    product: "Earphone G1",
    subProduct: "+3 Product",
    customer: "Alexander Green",
    username: "@alexgreen",
    total: "$14,000",
    payment: "Visa",
    date: "14 Jan 2024",
    time: "10:00",
    status: "Pending"
  },
  {
    product: "TWS Earphone Z",
    subProduct: "+3 Product",
    customer: "Andrew Walter",
    username: "@andrewwalt",
    total: "$27,000",
    payment: "Transfer",
    date: "14 Jan 2024",
    time: "10:00",
    status: "Canceled"
  },
  {
    product: "Mouse Logic G",
    subProduct: "+3 Product",
    customer: "Benjamin Strong",
    username: "@benjamin",
    total: "$14,000",
    payment: "Visa",
    date: "14 Jan 2024",
    time: "10:00",
    status: "Success"
  },
  {
    product: "Berry Smartwatch",
    subProduct: "+3 Product",
    customer: "Brianna Walter",
    username: "@briannawalt",
    total: "$27,000",
    payment: "Transfer",
    date: "14 Jan 2024",
    time: "10:00",
    status: "Pending"
  },
  {
    product: "Laptop AirBook X",
    subProduct: "+3 Product",
    customer: "Charles Reed",
    username: "@charlesr",
    total: "$35,000",
    payment: "Transfer",
    date: "15 Jan 2024",
    time: "09:45",
    status: "Success"
  },
  {
    product: "Smart TV Vision 55",
    subProduct: "+2 Product",
    customer: "Diana Holmes",
    username: "@dianah",
    total: "$42,000",
    payment: "Visa",
    date: "15 Jan 2024",
    time: "10:30",
    status: "Pending"
  },
  {
    product: "Bluetooth Speaker Max",
    subProduct: "+4 Product",
    customer: "Ethan Brown",
    username: "@ethanb",
    total: "$12,500",
    payment: "PayPal",
    date: "16 Jan 2024",
    time: "11:10",
    status: "Success"
  },
  {
    product: "Gaming Console X",
    subProduct: "+3 Product",
    customer: "Fiona Carter",
    username: "@fionac",
    total: "$55,000",
    payment: "Transfer",
    date: "16 Jan 2024",
    time: "13:20",
    status: "Canceled"
  },
  {
    product: "Drone Pro M7",
    subProduct: "+2 Product",
    customer: "George Smith",
    username: "@georges",
    total: "$48,000",
    payment: "Visa",
    date: "17 Jan 2024",
    time: "14:00",
    status: "Pending"
  }


];

export { PRO_ITEMS_COLUMNS, ROWS };